import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ReactNode } from 'react';
import {StripeElementsOptionsClientSecret} from "@stripe/stripe-js/dist/stripe-js/elements-group";

// TODO: should we add sentry here?

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Load Stripe outside the component to avoid recreating the Stripe object on every render
const stripePromise = loadStripe(publishableKey);

interface StripeWrapperProps {
    clientSecret: string;
    children: ReactNode;
}

const StripeWrapper: React.FC<StripeWrapperProps> = ({ clientSecret, children }) => {
    const options: StripeElementsOptionsClientSecret = {
        clientSecret,
        // appearance: {
        //     theme: 'stripe',
        //     variables: {
        //         borderRadius: '100px',
        //     }
        // }
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            {children}
        </Elements>
    );
};

export default StripeWrapper;
